import API from "../../utils/API";

export const logoutActions = () => (dispatch) => {
	API.post('/rest-auth/logout/',{}, (error, res) => {
		localStorage.removeItem('token');
		window.location.reload();
	})
};
